import { createStore, applyMiddleware, combineReducers } from 'redux'
import thunk from 'redux-thunk'
import { movieDetailReducer } from '@reducers/detailsReducer'
import { composeWithDevTools } from 'redux-devtools-extension'
import profileReducer from '@reducers/profileReducer'
import { useSelector, TypedUseSelectorHook } from 'react-redux'
import menuReducer from '@reducers/menuReducer'
import pageReducer from '@reducers/pageReducer'
import skeletonReducer from '@reducers/skeletonReducer'
import playerReducer from '@reducers/playerReducer'
import countryReducer from '@reducers/countryReducer'
import pageNotFoundReducer from '@reducers/pageNotFoundReducer'
import errorCodeReducer from '@reducers/errorCodeReducer'

const rootReducer = combineReducers({
  movie: movieDetailReducer,
  profile: profileReducer,
  page: pageReducer,
  skeleton: skeletonReducer,
  menu: menuReducer,
  player: playerReducer,
  userCountry:countryReducer,
  pageNotFound: pageNotFoundReducer,
  errorCode: errorCodeReducer,
})
export const store = createStore(rootReducer, composeWithDevTools(applyMiddleware(thunk)))

export type RootState = ReturnType<typeof rootReducer>
export const useTypedSelector: TypedUseSelectorHook<RootState> = useSelector
